// Reglas puras del wizard (sin DOM): pasos, validación, etiqueta del botón y formato de precio; `node --test`.
// Doc: _docs/features/products/partner_product_form.md

export const STEPS = ["Producto", "Precio", "Opciones", "Revisión"]

// Mensaje del paso ("" si es válido); orden de chequeos del prototipo: nombre, foto, sección
export function stepHint(step, state) {
  switch (step) {
    case 1:
      if (!state.name) return "Escribe el nombre del producto"
      if (state.photo !== "ready" && state.photo !== "uploading") return "Agrega una foto del producto"
      if (!state.section) return "Elige la sección del menú"
      return ""
    case 2:
      if (!state.price) return "Escribe el precio"
      return state.discountError || ""
    case 3:
      if (state.hasOptions === null || state.hasOptions === undefined) return "Elige si el cliente podrá elegir opciones"
      return state.optionsError || ""
    default:
      return ""
  }
}

// Listo = sin mensaje y sin nada en vuelo
export function stepReady(step, state) {
  return stepHint(step, state) === "" && !(step === 1 && state.photo === "uploading")
}

export function firstIncompleteStep(state) {
  return [1, 2, 3].find(step => !stepReady(step, state)) || null
}

export function primaryLabel(mode, step) {
  if (mode === "edit") return "Guardar cambios"
  return step === STEPS.length ? "Guardar producto" : "Continuar"
}

// El tope lo manda la vista (Product::MAX_CATEGORIES); mismo texto que wizard_categories_count en Ruby
export function categoriesCount(count, max) {
  return `Hasta ${max} · ${count} ${count === 1 ? "elegida" : "elegidas"}`
}

// "$2.640": miles con punto y sin decimales, igual que catalog_price en Ruby.
export function formatMoney(amount) {
  const value = Math.round(Number(amount) || 0)
  return "$" + String(Math.abs(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

// ---------- Revisión ----------

export function groupsCount(count) {
  return `${count} ${count === 1 ? "grupo" : "grupos"}`
}

// Filas del resumen (paso Revisión) a partir del estado que publica product-wizard
export function reviewRows(state) {
  const base = Number(state.price) || 0
  const discount = state.discount || {}
  const discounted = discount.active && discount.final !== null && discount.final !== undefined
  const options = state.options || {}
  const units = options.hasOptions ? (options.units || []) : []
  const groups = units.flatMap(unit => unit.groups || [])
  return {
    product: {
      value: state.name || "Sin nombre",
      sub: [state.sectionLabel || "Sin sección", ...(state.categories || [])].join(" · ")
    },
    price: {
      value: discounted ? `${formatMoney(discount.final)} con −${discount.percent}% (antes ${formatMoney(base)})` : formatMoney(base),
      sub: `${discounted ? discount.line : "Sin descuento"} · ${state.stock === null || state.stock === undefined ? "Stock ilimitado" : `${state.stock} en stock`}`
    },
    options: {
      value: !options.hasOptions ? "Se vende tal cual"
        : options.split ? units.map(unit => `${unit.label} × ${unit.quantity}`).join(" + ")
        : groupsCount(groups.length),
      sub: options.hasOptions ? groups.map(group => group.name).join(" · ") : "Sin opciones para elegir"
    }
  }
}

// "Burger · Verduras: Tu cliente debe elegir al menos 1, sin límite." (una por grupo, solo con opciones)
export function reviewRules(state, sentenceFor) {
  const options = state.options || {}
  if (!options.hasOptions) return []
  return (options.units || []).flatMap(unit => (unit.groups || []).map(group => ({
    name: options.split ? `${unit.label} · ${group.name}` : group.name,
    sentence: sentenceFor(group)
  })))
}
